export enum TRACKING_ORIGIN {
  HEADER = 'global-header',
  FOOTER = 'global-footer',
}
